// Interfaces
import { ITooltipText } from "./interfaces";

// Components
import TextFieldExtension from "./TextFieldExtension";

// MUI
import { Typography, Tooltip, Stack } from "@mui/material";

export default function TooltipText(props: Readonly<ITooltipText>) {
	const { tooltipMessage = "" } = props;
	return (
		<Tooltip arrow title={<Typography className="!font-sans !text-[14px] !text-white">{tooltipMessage}</Typography>}>
			<Stack>
				<TextFieldExtension {...props} />
			</Stack>
		</Tooltip>
	);
}
